import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Remove Service Workers antigos (ngsw) e caches associados.
// Necessário para tablets/navegadores que ainda tenham SW de deploys anteriores.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    registrations.forEach(function (registration) {
      registration.unregister();
    });
  });
}

if (typeof window !== 'undefined' && window.caches) {
  caches.keys().then(function (keys) {
    keys.forEach(function (key) {
      // limpa principalmente caches do Angular SW (ngsw:*)
      if (key.indexOf('ngsw:') === 0 || key.indexOf('ngsw') !== -1) {
        caches.delete(key);
      }
    });
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
